import React from 'react'
import { ResetPasswordForm } from '../components/Auth/ResetPasswordForm'
const ResetPassword = () => {
  return <ResetPasswordForm />
}

export {ResetPassword}